import educationalConceptGoals from './educationalConceptGoals.js'
import event from './event.js'
import eventPersons from './eventPersons.js'
import executedPrograms from './executedPrograms.js'
import locationProjects from "./locationProjects.js"
import projectDays from "./projectDays.js"

export default {
    organisation_id: 'Organisation',
    creator_user_id: 'Ersteller',
    process_id: 'Vorgang',
    year_id: 'Jahr',
    bankAccount: 'Bankverbindung',
    bank_account_id: 'Bankverbindung',
    formable_id: 'Formular',
    formable_type: 'Formulartyp',
    status_id: 'Status',
    internal_reference_number: 'Interne Bearbeitungsnummer',
    data: 'Formulardaten',
    sign: 'Unterschrift',
    projectDaysData: 'Projekttage-Daten',
    projectDaysDataProjectDays: 'Projekttage',
    projectDaysDataTotalProjectDaysDuration: 'Summe der Projekttage',
    projectDaysByHoursData: 'Projekttage nach Stunden',
    projectDaysByHoursDataProjectDays: 'Projekttage',
    projectDaysByHoursDataTotalProjectDaysDuration: 'Summe der Projekttage',
    projectDaysByHoursDataTotalProjectHoursDuration: 'Dauer der Projekttage in Stunden',

    educationalConceptGoals,
    event,
    eventPersons,
    executedPrograms,
    locationProjects,
    projectDays,

    documents: {
        document_id: 'Dokumenten-ID',
        form_process_id: 'Formularvorgangs-ID',
        upload_box_identifier: 'Upload-Box',
        visibility_section: 'Sichtbarkeit',

        noDocuments: 'Keine Dokumente hochgeladen',
        delete: 'Löschen',
        deleteDocument: 'Dokument löschen',
        deleteDocumentText: 'Möchtest du dieses Dokument wirklich löschen?'
    },

    signature: {
        title: 'Unterschrift',
        signature: 'Unterschrift',
        signFormProcess: 'Formular speichern und unterschreiben',
        information: 'Unterschreibe das Formular erst, wenn es vollständig ausgefüllt ist und abgeschickt werden soll.',
        unknownUser: 'Unbekannter Nutzer',
        scanQrCode: 'Scanne den QR-Code, um das Formular auf deinem Smartphone zu unterschreiben.',
        missingScanningDevice: 'Kein Gerät zum einscannen?',
        signOnThisDevice: 'Auf diesem Gerät unterschreiben.',
        signatory: 'Unterschreibende Person',
    },

    couldNotSendInCurrentStatus: 'Das Formular kann in diesem Vorgangsstatus nicht abgeschickt werden. Bitte wende dich an deinen Verband.',
    formReadyForSending: 'Das Formular ist bereit zum Absenden.',
    formReadyForSendingText: 'Das Formular wurde unterschrieben und kann nicht weiter bearbeitet werden.',
    removeSignature: 'Unterschrift entfernen',
    signAndSendHelpText: 'Du kannst das Formular entweder direkt hier digital unterschreiben, oder du schickst es ab, druckst es aus, unterschreibst es und schickst es dann per Post an deinen Verband.',
    markForSending: 'Um das Formular Absenden zu können, muss zuerst die Statistik ausgefüllt werden.<br>' +
        'Das Formular kann aber mit Klick auf "Zum Absenden vormerken und weiter zu Statistik" zum Absenden vorgemerkt' +
        'werden und sobald die Statistik abgeschickt wurde, wird automatisch auch das Formular abgeschickt.',

    formLocked: 'Das Formular ist gesperrt.',
    formLockedText: 'Das Formular wurde abgeschickt und kann nicht weiter bearbeitet werden.',

    managementArea: {
        formLocked: 'Das Formular ist gesperrt.',
        formLockedText: 'Das Formular wurde abgeschickt und kann nicht weiter bearbeitet werden.',
        formLockedInApplicationArea: 'Das Formular ist für den Antragsteller gesperrt.',
        formLockedInApplicationAreaText: 'Das Formular wurde unterschrieben und kann vom Antragsteller nicht weiter bearbeitet werden.<br><br>Falls der Antragsteller das Formular noch einmal bearbeiten muss, setze den Vorgang auf den Status "Überarbeitung" zurück.',
    },

    submit: 'Absenden',
    saveDraft: 'Entwurf speichern',
    reviewDraft: 'Zur Durchsicht freigeben',
    createSuccess: 'Das Formular wurde erfolgreich angelegt.',
    createError: 'Das Formular konnte nicht angelegt werden.',
    saveSuccess: 'Das Formular wurde erfolgreich gespeichert.',
    saveError: 'Das Formular konnte nicht gespeichert werden.',

    formNavigator: {
        newFormProcess: 'Neues Formular',
        newProcess: 'Neuer Vorgang',
        saveDraft: 'Entwurf speichern',
        reviewDraft: 'Zur Durchsicht freigeben',
        backToProcesses: 'Zurück zur Vorgangsübersicht',
    },

    print: {
        title: 'PDF erzeugen',
        descriptionFormProcess: 'Für wen soll die PDF vom Formular {formIdentifier} erzeugt werden?',
        descriptionProcess: 'Für wen soll die PDF vom Vorgang {vNumber} erzeugt werden?',

        printForOptions: {
            applicant: 'Zuschussbeantragende',
            manager: 'Zuschussverwaltende',
            donor: 'Zuschussgebende'
        },

        printSuccess: 'Die PDF wurde erfolgreich erzeugt.',
        printError: 'Die PDF konnte nicht erzeugt werden.'
    },

    deleteFormProcess: 'Formular löschen',
    deleteFormProcessText: 'Möchtest du dieses Formular wirklich löschen?',
    deleteFormProcessTextLastForm: 'Der Vorgang wird bei dieser Aktion ebenfalls gelöscht.',
    deleteFormProcessSuccess: 'Formular wurde erfolgreich gelöscht.',
    deleteFormProcessError: 'Das Formular konnte nicht gelöscht werden.'
}